import React from "react";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { getFormattedPrice, ReceiptTotal } from "@qgiv/core-donor";
import { hasActiveProductsToBeDisplayed } from "@qgiv/p2p-registration";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllProducts } from "../../../redux/slices/productsSlice";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectThemeSettings } from "../../../redux/slices/cmsSettingsSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { ThemeType } from "../../../redux/constants";

const ConnectedReceiptTotal = () => {
    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const isCms = useSelector(selectIsCms);
    const receipt = useSelector(selectReceipt);
    const products = useSelector(selectAllProducts);
    const hasProducts = hasActiveProductsToBeDisplayed(products);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { registrationFeeDisplay, registrationFeeDisplayText } = p2pSettings;
    const {
        transaction: {
            amount = 0.0,
            promoCodes = [],
            originalTransactionFee = 0.0,
        },
    } = receipt;
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pGeneral: { totalLabel = "Total" },
    } = themeSettings;

    const hasPromo = promoCodes.length > 0 && originalTransactionFee > amount;

    // Hardcoded cms default total if store is available on registration
    const cmsDefaultTotalWithStore = "93.80";

    // Generate flags used to display different parts of the UI
    // The hourglass icon, the invoice icon, the invoice status, the pending
    // status and the recurring text are never displayed here as those parts
    // of the UI are used for ongoing donations and invoices which are not a
    // part of P2P registration.
    const displayHourGlassIcon = false;
    const displayInvoiceIcon = false;
    const displayInvoiceStatus = false;
    const displayOriginalPrice = !!hasPromo;
    const displayPendingStatus = false;
    const displayPromoCodes = !!hasPromo;
    const displayRecurringText = false;

    const receiptTotalProps = {
        displayHourGlassIcon,
        displayInvoiceIcon,
        displayInvoiceStatus,
        displayOriginalPrice,
        displayPendingStatus,
        displayPromoCodes,
        displayRecurringText,
        hasPromo,
        formattedOriginalPrice: currencyString(
            originalTransactionFee,
            currency,
        ),
        promoCodes,
        total:
            isCms && hasProducts
                ? currencyString(cmsDefaultTotalWithStore, currency)
                : getFormattedPrice(
                      amount,
                      currency,
                      registrationFeeDisplay,
                      registrationFeeDisplayText,
                      hasPromo,
                  ),
        totalLabel,
    };

    return <ReceiptTotal {...receiptTotalProps} />;
};

export default ConnectedReceiptTotal;
